import { render, staticRenderFns } from "./MembershipFiliation.vue?vue&type=template&id=defb1064"
import script from "./MembershipFiliation.vue?vue&type=script&lang=js"
export * from "./MembershipFiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports